import { apiClient } from "./api";

export const authService = {
  login: (email, password) =>
    apiClient.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => apiClient.post("/auth/logout").then((r) => r.data),
  me: () => apiClient.get("/auth/me").then((r) => r.data),
  forgotPassword: (email) =>
    apiClient.post("/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: (token, password) =>
    apiClient.post("/auth/reset-password", { token, password }).then((r) => r.data),
  acceptInvitation: (token, name, password) =>
    apiClient
      .post("/auth/accept-invitation", { token, name, password })
      .then((r) => r.data),
};
